import axios from 'axios'
import { getHeaders, getError } from '../helpers'
import config from '../../constants/endpoints.js'
const {
  endpoints: { shorten: url },
} = config

const shortenUrl = (data) => axios.post(url, data, { headers: getHeaders(true) })

/**
 * Short URL
 * @param {[string]} payload
 *
 * @returns Promise<[{url: string, urlLong: string}]>
 */
const shortURL = async function (payload) {
  if (!payload || !Array.isArray(payload)) throw new Error('payload is not an array.')
  if (!payload.length) return []

  try {
    const { data } = await axios({
      method: 'post',
      url: url,
      headers: getHeaders(true),
      data: { urls: payload }
    })

    return data.result
  } catch(error) {
    throw getError(error)
  }
}

/**
* Short One URL
* @param {string} payload
*
* @returns Promise<{url: string, urlLong: string}>
*/
const shortOneURL = async function (payload) {
  if (!payload || typeof payload !== 'string') throw new Error('payload is not a string.')

  const result = await shortURL([payload])

  return result[0] || {}
}

export default {
  shortenUrl,
  shortURL,
  shortOneURL
}
